const css = `.xO2fKW__button{cursor:pointer;outline-offset:3px;outline:3px solid #0000;position:relative}.xO2fKW__button:focus-visible{outline:3px solid var(--base-strokes-focus);outline-offset:3px;z-index:1}.xO2fKW__button.xO2fKW__disabled{cursor:default}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"disabled":"xO2fKW__disabled","button":"xO2fKW__button"};
